import { Client, Stream } from 'agora-rtc-sdk'
import { generate } from 'randomstring'
import { AgoraClientId, StreamId } from 'components/features/videoCalls/types/agoraTypes'


class AgoraInstances {
  clients = new Map<AgoraClientId, Client>()
  streams = new Map<StreamId, Stream>()

  addClient = (client: Client): AgoraClientId => {
    const id = generate()
    this.clients.set(id, client)
    return id
  }
}

export const agoraInstances = new AgoraInstances()
